"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var ModelResultSlice_1 = require("../../../store/slice/ModelResultSlice");
var MapperUtils_1 = require("../../../util/MapperUtils");
var Utils_1 = require("../../../util/Utils");
var ModelResultAlertDetails = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), alerts = _a.alerts, isImprovement = _a.isImprovement, type = _a.type;
    var recommendedAlerts = (0, MapperUtils_1.getRecommendedAlerts)(alerts);
    var dispatch = (0, react_redux_1.useDispatch)();
    var barColor = (0, Utils_1.isBinomialModel)(type) ? prediction_model_results_viz_1.VizColors.background02 : undefined;
    // If it's an improvement get the subject from a label, otherwise just use the alert subject
    isImprovement &&
        recommendedAlerts.forEach(function (alert) {
            var improvementSubject = null;
            switch (alert.type) {
                case 'DataLeakage':
                    improvementSubject = Localize_1.Messages.dataLeakageTitle();
                    break;
                case 'CollinearFields':
                    improvementSubject = Localize_1.Messages.collinearFieldsTitle();
                    break;
                case 'ExtremeValues':
                    improvementSubject = Localize_1.Messages.extremeValuesTitle();
                    break;
                case 'ObviousPredictor':
                    improvementSubject = Localize_1.Messages.obviousPredictorTitle();
                    break;
                case 'SingleValue':
                    improvementSubject = Localize_1.Messages.singleValueTitle();
                    break;
                case 'SingleValueWithOther':
                    improvementSubject = Localize_1.Messages.singleValueWithOtherTitle();
                    break;
                case 'CorrelateWithProtectedFields':
                    improvementSubject = Localize_1.Messages.correlateWithProtectedFieldsTitle();
                    break;
                case 'DisparateImpact':
                    improvementSubject = Localize_1.Messages.disparateImpactTitle();
                    break;
                case 'RecommendedBuckets':
                    improvementSubject = Localize_1.Messages.recommendedBucketsTitle();
                    break;
                case 'ImbalancedDistribution':
                    improvementSubject = Localize_1.Messages.imbalancedDistributionTitle();
                    break;
                case 'HighCardinality':
                    improvementSubject = Localize_1.Messages.highCardinalityTitle();
                    break;
                case 'MissingValues':
                    improvementSubject = Localize_1.Messages.missingValuesTitle();
                    break;
                case 'MissingCategoricalValues':
                    improvementSubject = Localize_1.Messages.missingCategoricalValuesTitle();
                    break;
                case 'CrossValidationFailed':
                    improvementSubject = Localize_1.Messages.crossValidationFailedTitle();
                    break;
            }
            if (improvementSubject) {
                dispatch((0, ModelResultSlice_1.setAlertSubject)({ id: alert.id, subject: improvementSubject }));
            }
        });
    return (React.createElement(prediction_model_results_viz_1.AlertListComponent, { alerts: recommendedAlerts, isImprovement: isImprovement, hideBorder: true, color: barColor }));
};
exports.default = ModelResultAlertDetails;
//# sourceMappingURL=ModelResultAlertDetails.js.map